import ReactApexChart from "react-apexcharts";

export default function CandleStickChart({
  candlestick,
  allFData,
  levels,
  overLays,
  allData,
}) {
  const seriesData = [];
  const ppYaxis = [];
  const points = [];
  const xaxis = [];
  const sfivedmaCal = allData?.sfivedmaCal;
  seriesData.push({
    name: "candle",
    type: "candlestick",
    data: candlestick
      ? candlestick.map((item) => ({
          x: item.x,
          y: [item.o, item.h, item.l, item.c],
        }))
      : [],
  });
  const alertData = allData?.alertData;
  const dateValue = sfivedmaCal
    ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.pp }))
    : [];
  if (alertData?.buy) {
    points.push({
      x: dateValue?.[27]?.x,
      y: alertData?.value,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: alertData?.buy,
      },
    });
  }
  if (alertData?.sell) {
    points.push({
      x: dateValue?.[27]?.x,
      y: alertData?.value,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: alertData?.sell,
      },
    });
  }
  const showSMA = (movingValue, text) => {
    const openValue = parseFloat(allData?.op);
    const ltpValue = parseFloat(allData?.ltp);
    let movingText = text;
    let backgroundColor = "#00E396";
    if (
      openValue < parseFloat(movingValue) &&
      ltpValue > parseFloat(movingValue)
    ) {
      backgroundColor = "rgb(0, 183, 70)";
      movingText = ` ${movingText}-Buy`;
    } else if (
      openValue > parseFloat(movingValue) &&
      ltpValue < parseFloat(movingValue)
    ) {
      backgroundColor = "#FF4560";
      movingText = ` ${movingText}-Sell`;
    }
    return { movingText: movingText, backgroundColor: backgroundColor };
  };

  if (overLays?.includes("1") && candlestick) {
    const itemData = allData?.sfivedmaCal
      ? allData?.sfivedmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];

    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 5");
    xaxis.push({
      x: itemData?.[0]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 5", type: "line", data: itemData });
  }
  if (overLays?.includes("2") && candlestick) {
    const itemData = allData?.stendmaCal
      ? allData?.stendmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    const indexValue = overLays.length > 1 && overLays?.includes("1") ? 2 : 0;
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 10");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 10", type: "line", data: itemData });
  }
  if (overLays?.includes("3") && candlestick) {
    const itemData = allData?.stwentydmaCal
      ? allData?.stwentydmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 20");
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 20", type: "line", data: itemData });
  }
  if (overLays?.includes("4") && candlestick) {
    const itemData = allData?.sthirtydmaCal
      ? allData?.sthirtydmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 30");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 30", type: "line", data: itemData });
  }
  if (overLays?.includes("5") && candlestick) {
    const itemData = allData?.sthirtyfourdmaCal
      ? allData?.sthirtyfourdmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 34");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 34", type: "line", data: itemData });
  }
  if (overLays?.includes("6") && candlestick) {
    const itemData = allData?.sfiftydmaCal
      ? allData?.sfiftydmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 50");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 50", type: "line", data: itemData });
  }
  if (overLays?.includes("7") && candlestick) {
    const itemData = allData?.seightyninedmaCal
      ? allData?.seightyninedmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 89");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 89", type: "line", data: itemData });
  }
  if (overLays?.includes("8") && candlestick) {
    const itemData = allData?.shundreddmaCal
      ? allData?.shundreddmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 100");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 100", type: "line", data: itemData });
  }
  if (overLays?.includes("9") && candlestick) {
    const itemData = allData?.sonefiftydmaCal
      ? allData?.sonefiftydmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 150");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 150", type: "line", data: itemData });
  }
  if (overLays?.includes("10") && candlestick) {
    const itemData = allData?.stwohundreddmaCal
      ? allData?.stwohundreddmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "SMA 200");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "SMA 200", type: "line", data: itemData });
  }

  if (overLays?.includes("11") && candlestick) {
    const itemData = allData?.efivedmaCal
      ? allData?.efivedmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }

    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 5");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 5", type: "line", data: itemData });
  }
  if (overLays?.includes("12") && candlestick) {
    const itemData = allData?.etendmaCal
      ? allData?.etendmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 10");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 10", type: "line", data: itemData });
  }
  if (overLays?.includes("13") && candlestick) {
    const itemData = allData?.etwentydmaCal
      ? allData?.etwentydmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("13")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 20");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 20", type: "line", data: itemData });
  }
  if (overLays?.includes("14") && candlestick) {
    const itemData = allData?.ethirtydmaCal
      ? allData?.ethirtydmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("13")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("14")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 30");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 30", type: "line", data: itemData });
  }
  if (overLays?.includes("15") && candlestick) {
    const itemData = allData?.ethirtyfourdmaCal
      ? allData?.ethirtyfourdmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("13")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("14")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("15")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 34");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 34", type: "line", data: itemData });
  }
  if (overLays?.includes("16") && candlestick) {
    const itemData = allData?.efiftydmaCal
      ? allData?.efiftydmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("13")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("14")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("15")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("16")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 50");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 50", type: "line", data: itemData });
  }
  if (overLays?.includes("17") && candlestick) {
    const itemData = allData?.eeightyninedmaCal
      ? allData?.eeightyninedmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("13")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("14")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("15")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("16")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("17")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 89");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 89", type: "line", data: itemData });
  }
  if (overLays?.includes("18") && candlestick) {
    const itemData = allData?.ehundreddmaCal
      ? allData?.ehundreddmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("13")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("14")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("15")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("16")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("17")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("18")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 100");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 100", type: "line", data: itemData });
  }

  if (overLays?.includes("19") && candlestick) {
    const itemData = allData?.eonefiftydmaCal
      ? allData?.eonefiftydmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("13")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("14")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("15")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("16")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("17")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("18")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("19")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 150");
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 150", type: "line", data: itemData });
  }
  if (overLays?.includes("20") && candlestick) {
    const itemData = allData?.etwohundreddmaCal
      ? allData?.etwohundreddmaCal.map((item) => ({ x: item.x, y: item?.val }))
      : [];
    let indexValue = 0;
    if (overLays?.includes("1")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("2")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("3")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("4")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("5")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("6")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("7")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("8")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("9")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("10")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("11")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("12")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("13")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("14")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("15")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("16")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("17")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("18")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("19")) {
      indexValue = indexValue + 1;
    }
    if (overLays?.includes("20")) {
      indexValue = indexValue + 1;
    }
    const length = itemData?.length;
    const movingValue = itemData?.[length - 1]?.["y"];
    const plotValue = showSMA(movingValue, "EMA 200");
    console.log("itemData", itemData);
    xaxis.push({
      x: itemData?.[indexValue]?.x,
      label: {
        borderColor: plotValue?.backgroundColor,
        style: {
          color: "#fff",
          background: plotValue?.backgroundColor,
        },
        text: plotValue?.movingText,
      },
    });
    seriesData.push({ name: "EMA 200", type: "line", data: itemData });
  }

  // const vol = candlestick
  //   ? candlestick.map((item) => ({ x: item.x, y: item?.volume }))
  //   : [];
  // seriesData.push({ name: "Volume", type: "column", data: vol });

  //const sfivedmaCal = allData?.sfivedmaCal;
  if (levels == 1 && candlestick) {
    const pp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.pp }))
      : [];
    const rone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.rone }))
      : [];

    const rtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.rtwo }))
      : [];
    const rthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.rthree }))
      : [];
    const sone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.sone }))
      : [];
    const stwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.stwo }))
      : [];
    const sthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.sthree }))
      : [];
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.pp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "PP",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.rone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R1",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.rtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R2",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.rthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R3",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.sone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S1",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.stwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S2",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.sthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S3",
      },
    });
    seriesData.push({ name: "PP", type: "line", data: pp });
    seriesData.push({ name: "R1", type: "line", data: rone });
    seriesData.push({ name: "R2", type: "line", data: rtwo });
    seriesData.push({ name: "R3", type: "line", data: rthree });
    seriesData.push({ name: "S1", type: "line", data: sone });
    seriesData.push({ name: "S2", type: "line", data: stwo });
    seriesData.push({ name: "S3", type: "line", data: sthree });
  }

  if (levels == 2 && candlestick) {
    const wpp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.wpp }))
      : [];
    const wrone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.wrone }))
      : [];
    const wrtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.wrtwo }))
      : [];
    const wrthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.wrthree }))
      : [];
    const wsone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.wsone }))
      : [];
    const wstwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.wstwo }))
      : [];
    const wsthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.wsthree }))
      : [];
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.wpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "W PP",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.wrone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R1",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.wrtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R2",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.wrthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R3",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.wsone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S1",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.wstwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S2",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.wsthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S3",
      },
    });
    seriesData.push({ name: "W PP", type: "line", data: wpp });
    seriesData.push({ name: "W R1", type: "line", data: wrone });
    seriesData.push({ name: "W R2", type: "line", data: wrtwo });
    seriesData.push({ name: "W R3", type: "line", data: wrthree });
    seriesData.push({ name: "W S1", type: "line", data: wsone });
    seriesData.push({ name: "W S2", type: "line", data: wstwo });
    seriesData.push({ name: "W S3", type: "line", data: wsthree });
  }

  if (levels == 3 && sfivedmaCal) {
    const mpp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.mpp }))
      : [];
    const mrone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.mrone }))
      : [];
    const mrtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.mrtwo }))
      : [];
    const mrthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.mrthree }))
      : [];
    const msone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.msone }))
      : [];
    const mstwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.mstwo }))
      : [];
    const msthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.msthree }))
      : [];
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.mpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "M PP",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.mrone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R1",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.mrtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R2",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.mrthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R3",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.msone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S1",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.mstwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S2",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.msthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S3",
      },
    });
    seriesData.push({ name: "M PP", type: "line", data: mpp });
    seriesData.push({ name: "M R1", type: "line", data: mrone });
    seriesData.push({ name: "M R2", type: "line", data: mrtwo });
    seriesData.push({ name: "M R3", type: "line", data: mrthree });
    seriesData.push({ name: "M S1", type: "line", data: msone });
    seriesData.push({ name: "M S2", type: "line", data: mstwo });
    seriesData.push({ name: "M S3", type: "line", data: msthree });
  }

  if (levels == 4 && sfivedmaCal) {
    const bintraday = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.bintraday }))
      : [];
    const bshortterm = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.bshortterm }))
      : [];
    const blongterm = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.blongterm }))
      : [];

    ppYaxis.push({
      y: allFData?.bintraday,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Intraday",
      },
    });
    ppYaxis.push({
      y: allFData?.bshortterm,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Shot Term",
      },
    });
    ppYaxis.push({
      y: allFData?.blongterm,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Long Term",
      },
    });
    seriesData.push({ name: "Intraday", type: "line", data: bintraday });
    seriesData.push({ name: "Shot Term", type: "line", data: bshortterm });
    seriesData.push({ name: "Long Term", type: "line", data: blongterm });
  }

  if (levels == 5 && sfivedmaCal) {
    const sintraday = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.sintraday }))
      : [];
    const sshortterm = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.sshortterm }))
      : [];
    const slongterm = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.slongterm }))
      : [];

    ppYaxis.push({
      y: allFData?.sintraday,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Intraday",
      },
    });
    ppYaxis.push({
      y: allFData?.sshortterm,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Shot Term",
      },
    });
    ppYaxis.push({
      y: allFData?.slongterm,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Long Term",
      },
    });
    seriesData.push({ name: "Intraday", type: "line", data: sintraday });
    seriesData.push({ name: "Shot Term", type: "line", data: sshortterm });
    seriesData.push({ name: "Long Term", type: "line", data: slongterm });
  }

  if (levels == 6 && candlestick) {
    const pp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cpp }))
      : [];
    const rone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.crone }))
      : [];
    const rtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.crtwo }))
      : [];
    const rthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.crthree }))
      : [];
    const sone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.csone }))
      : [];
    const stwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cstwo }))
      : [];
    const sthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.csthree }))
      : [];

    points.push({
      x: pp?.[0]?.x,
      y: allFData?.cpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "PP",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.crone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R1",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.crtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R2",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.crthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R3",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.csone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S1",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.cstwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S2",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.csthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S3",
      },
    });
    seriesData.push({ name: "PP", type: "line", data: pp });
    seriesData.push({ name: "R1", type: "line", data: rone });
    seriesData.push({ name: "R2", type: "line", data: rtwo });
    seriesData.push({ name: "R3", type: "line", data: rthree });
    seriesData.push({ name: "S1", type: "line", data: sone });
    seriesData.push({ name: "S2", type: "line", data: stwo });
    seriesData.push({ name: "S3", type: "line", data: sthree });
  }

  if (levels == 7 && sfivedmaCal) {
    const wpp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cwpp }))
      : [];
    const wrone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cwrone }))
      : [];
    const wrtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cwrtwo }))
      : [];
    const wrthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cwrthree }))
      : [];
    const wsone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cwsone }))
      : [];
    const wstwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cwstwo }))
      : [];
    const wsthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cwsthree }))
      : [];

    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cwpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "W PP",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cwrone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R1",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cwrtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R2",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cwrthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R3",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cwsone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S1",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cwstwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S2",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cwsthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S3",
      },
    });
    seriesData.push({ name: "W PP", type: "line", data: wpp });
    seriesData.push({ name: "W R1", type: "line", data: wrone });
    seriesData.push({ name: "W R2", type: "line", data: wrtwo });
    seriesData.push({ name: "W R3", type: "line", data: wrthree });
    seriesData.push({ name: "W S1", type: "line", data: wsone });
    seriesData.push({ name: "W S2", type: "line", data: wstwo });
    seriesData.push({ name: "W S3", type: "line", data: wsthree });
  }

  if (levels == 8 && sfivedmaCal) {
    const mpp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cmpp }))
      : [];
    const mrone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cmrone }))
      : [];
    const mrtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cmrtwo }))
      : [];
    const mrthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cmrthree }))
      : [];
    const msone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cmsone }))
      : [];
    const mstwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cmstwo }))
      : [];
    const msthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cmsthree }))
      : [];

    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cmpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "M PP",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cmrone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R1",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cmrtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R2",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cmrthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R3",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cmsone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S1",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cmstwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S2",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cmsthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S3",
      },
    });
    seriesData.push({ name: "M PP", type: "line", data: mpp });
    seriesData.push({ name: "M R1", type: "line", data: mrone });
    seriesData.push({ name: "M R2", type: "line", data: mrtwo });
    seriesData.push({ name: "M R3", type: "line", data: mrthree });
    seriesData.push({ name: "M S1", type: "line", data: msone });
    seriesData.push({ name: "M S2", type: "line", data: mstwo });
    seriesData.push({ name: "M S3", type: "line", data: msthree });
  }

  if (levels == 9 && candlestick) {
    const pp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fpp }))
      : [];
    const rone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.frone }))
      : [];
    const rtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.frtwo }))
      : [];
    const rthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.frthree }))
      : [];
    const sone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fsone }))
      : [];
    const stwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fstwo }))
      : [];
    const sthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fsthree }))
      : [];
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.fpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "PP",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.frone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R1",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.frtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R2",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.frthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "R3",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.fsone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S1",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.fstwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S2",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.fsthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "S3",
      },
    });
    seriesData.push({ name: "PP", type: "line", data: pp });
    seriesData.push({ name: "R1", type: "line", data: rone });
    seriesData.push({ name: "R2", type: "line", data: rtwo });
    seriesData.push({ name: "R3", type: "line", data: rthree });
    seriesData.push({ name: "S1", type: "line", data: sone });
    seriesData.push({ name: "S2", type: "line", data: stwo });
    seriesData.push({ name: "S3", type: "line", data: sthree });
  }

  if (levels == 10 && sfivedmaCal) {
    const wpp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fwpp }))
      : [];
    const wrone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fwrone }))
      : [];
    const wrtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fwrtwo }))
      : [];
    const wrthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fwrthree }))
      : [];
    const wsone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fwsone }))
      : [];
    const wstwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fwstwo }))
      : [];
    const wsthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fwsthree }))
      : [];

    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.fwpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "W PP",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.fwrone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R1",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.fwrtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R2",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.fwrthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W R3",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.fwsone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S1",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.fwstwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S2",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.fwsthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "W S3",
      },
    });
    seriesData.push({ name: "W PP", type: "line", data: wpp });
    seriesData.push({ name: "W R1", type: "line", data: wrone });
    seriesData.push({ name: "W R2", type: "line", data: wrtwo });
    seriesData.push({ name: "W R3", type: "line", data: wrthree });
    seriesData.push({ name: "W S1", type: "line", data: wsone });
    seriesData.push({ name: "W S2", type: "line", data: wstwo });
    seriesData.push({ name: "W S3", type: "line", data: wsthree });
  }

  if (levels == 11 && sfivedmaCal) {
    const mpp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fmpp }))
      : [];
    const mrone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fmrone }))
      : [];
    const mrtwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fmrtwo }))
      : [];
    const mrthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fmrthree }))
      : [];
    const msone = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fmsone }))
      : [];
    const mstwo = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fmstwo }))
      : [];
    const msthree = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.fmsthree }))
      : [];

    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.fmpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cysn",
        },
        text: "M PP",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.fmrone,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R1",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.fmrtwo,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R2",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.fmrthree,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M R3",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.fmsone,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S1",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.fmstwo,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S2",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.fmsthree,
      label: {
        borderColor: "#FF4560",
        style: {
          color: "#fff",
          background: "#FF4560",
        },
        text: "M S3",
      },
    });
    seriesData.push({ name: "M PP", type: "line", data: mpp });
    seriesData.push({ name: "M R1", type: "line", data: mrone });
    seriesData.push({ name: "M R2", type: "line", data: mrtwo });
    seriesData.push({ name: "M R3", type: "line", data: mrthree });
    seriesData.push({ name: "M S1", type: "line", data: msone });
    seriesData.push({ name: "M S2", type: "line", data: mstwo });
    seriesData.push({ name: "M S3", type: "line", data: msthree });
  }

  if (levels == 12 && candlestick) {
    const pp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cppp }))
      : [];
    const cpbc = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cpbc }))
      : [];
    const cptc = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cptc }))
      : [];

    points.push({
      x: pp?.[0]?.x,
      y: allFData?.cppp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "PP",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.cpbc,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "BC",
      },
    });
    points.push({
      x: pp?.[0]?.x,
      y: allFData?.cptc,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "TC",
      },
    });
    seriesData.push({ name: "PP", type: "line", data: pp });
    seriesData.push({ name: "BC", type: "line", data: cpbc });
    seriesData.push({ name: "TC", type: "line", data: cptc });
  }

  if (levels == 13 && sfivedmaCal) {
    const wpp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cpwpp }))
      : [];
    const cpwbc = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cpwbc }))
      : [];
    const cpwtc = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cpwtc }))
      : [];

    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cpwpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "W PP",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cpwbc,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W BC",
      },
    });
    points.push({
      x: wpp?.[0]?.x,
      y: allFData?.cpwtc,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "W TC",
      },
    });
    seriesData.push({ name: "W PP", type: "line", data: wpp });
    seriesData.push({ name: "W BC", type: "line", data: cpwbc });
    seriesData.push({ name: "W TC", type: "line", data: cpwtc });
  }

  if (levels == 14 && sfivedmaCal) {
    const mpp = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cpmpp }))
      : [];
    const cpmbc = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cpmbc }))
      : [];
    const cpmtc = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.cpmtc }))
      : [];

    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cpmpp,
      label: {
        borderColor: "cyan",
        style: {
          color: "#fff",
          background: "cyan",
        },
        text: "M PP",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cpmbc,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M BC",
      },
    });
    points.push({
      x: mpp?.[0]?.x,
      y: allFData?.cpmtc,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "M TC",
      },
    });
    seriesData.push({ name: "M PP", type: "line", data: mpp });
    seriesData.push({ name: "M BC", type: "line", data: cpmbc });
    seriesData.push({ name: "M TC", type: "line", data: cpmtc });
  }

  if (levels == 15 && sfivedmaCal) {
    const high = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.high }))
      : [];
    const low = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.low }))
      : [];

    points.push({
      x: high?.[0]?.x,
      y: allFData?.high,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "High",
      },
    });
    points.push({
      x: low?.[0]?.x,
      y: allFData?.low,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Low",
      },
    });
    seriesData.push({ name: "High", type: "line", data: high });
    seriesData.push({ name: "Low", type: "line", data: low });
  }

  if (levels == 16 && sfivedmaCal) {
    const high = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.whigh }))
      : [];
    const low = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.wlow }))
      : [];

    points.push({
      x: high?.[0]?.x,
      y: allFData?.whigh,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "High",
      },
    });
    points.push({
      x: low?.[0]?.x,
      y: allFData?.wlow,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Low",
      },
    });
    seriesData.push({ name: "High", type: "line", data: high });
    seriesData.push({ name: "Low", type: "line", data: low });
  }

  if (levels == 17 && sfivedmaCal) {
    const high = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.mhigh }))
      : [];
    const low = sfivedmaCal
      ? sfivedmaCal.map((item) => ({ x: item.x, y: allFData?.mlow }))
      : [];

    points.push({
      x: high?.[0]?.x,
      y: allFData?.mhigh,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "High",
      },
    });
    points.push({
      x: low?.[0]?.x,
      y: allFData?.mlow,
      label: {
        borderColor: "#00E396",
        style: {
          color: "#fff",
          background: "#00E396",
        },
        text: "Low",
      },
    });
    seriesData.push({ name: "High", type: "line", data: high });
    seriesData.push({ name: "Low", type: "line", data: low });
  }

  const state = {
    series: seriesData,
    colors: ["#FF1654", "#247BA0"],

    options: {
      chart: {
        height: 350,
        type: "candlestick",
      },
      stroke: {
        width: [2, 2, 2, 2, 2, 2, 2, 2],
      },
      color: ["red", "pink"],
      xaxis: {
        type: "category",
        //tickPlacement: 'between',
      },
      dataLabels: {
        enabledOnSeries: "PP",
      },
      title: {
        text: allData?.symbol,
        align: "left",
      },
      annotations: {
        points: points,
        yaxis: ppYaxis,
        xaxis: xaxis,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "80%",
        colors: {
          ranges: [
            {
              from: -1000,
              to: 0,
              color: "#F15B46",
            },
            {
              from: 1,
              to: 10000,
              color: "#FEB019",
            },
          ],
        },
      },
    },
  };
  return (
    <>
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="candlestick"
        height={350}
      />
    </>
  );
}
